import axios from "axios";
import {
    ActivityLog,
    CreateUserPayload,
    DeleteUserPayload,
    SetCurrentCustomerPayload,
    UpdateUserPayload,
    UpdateUserRightPayload,
    User
} from "../Types/User";

export const fetchByBu = async (buIds: number[]): Promise<User[]> => {
  try {
    const response = await axios.get('/api/users/listByBu', {params: {'buIds': buIds}});

    return response.data
  } catch (error) {
    throw error;
  }
};
export const listUsersByIdsEc = async (buIds: number[]): Promise<User[]> => {
    try {
        const response = await axios.get('/api/users/listUsersByIdsEc', {params: {'buIds': buIds}});

        return response.data
    } catch (error) {
        throw error;
    }
};

export const getLogActivity = async(): Promise<ActivityLog[]> => {

    const {data} = await axios.get('/api/users/logActivity');
    return data;

}

export const updateUser = async (payload: UpdateUserPayload): Promise<unknown> => {
  try {
    const {data} = await axios.put(
      `/api/users/${payload.id}`,
      {
        'prenom': payload.first_name,
        'nom': payload.name,
        'email': payload.mail
      }
    );

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateRightUser = async (payload: UpdateUserRightPayload): Promise<unknown> => {
  try {
    const {data} = await axios.put(
      `/api/users/${payload.user}/roles`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
};


export const createUser = async (user: CreateUserPayload): Promise<unknown> => {
  try {
    const {data} = await axios.post(
      '/api/users',
      {
        'prenom': user.first_name,
        'nom': user.name,
        'email': user.mail,
        'idClient': user.entity_id,
        'system': user.system,
        'roles': user.roles,
      }
    );

    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (payload: DeleteUserPayload): Promise<unknown> => {
  try {
    const {data} = await axios.delete(`/api/users/${payload.id}`, {
      data: {entityIds: payload.entity_ids},
    });

    return data;
  } catch (error) {
    throw error;
  }
};



export const impersonate = async (user: User): Promise<void> => {
  await axios.post('/api/users/impersonate', {
    'impersonateUser': user.mail,
  })
}

export const removeImpersonate = async (): Promise<void> => {
  await axios.delete('/api/users/impersonate')
}

export const setCurrentCustomer = async (payload: SetCurrentCustomerPayload): Promise<App.Domains.Auth.Dto.Customer> => {
  const {data} = await axios.put('/api/users/me/current-customer', payload);

  return data;
}

export const clearCurrentCustomer = async (): Promise<void> => {
  await axios.delete('/api/users/me/current-customer')
}
